/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Templates_List_DescriptionInputs */



/**
* | output |
* | --- |
* | "Manage the templates that monitor or block sensitive content." |
*
* @param {Compliance_Templates_List_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_templates_list_description = /** @type {((inputs?: Compliance_Templates_List_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Templates_List_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verwalte die Vorlagen, die sensible Inhalte überwachen oder blockieren.")
	return /** @type {LocalizedString} */ ("Manage the templates that monitor or block sensitive content.")
});